import { createSlice, isAction } from '@reduxjs/toolkit'; 
const socketSlice = createSlice({ 
    name: 'socket', 
    initialState: { 
        instance: null, 
        newTrade : {},
        targetStoplossChange : {},
        updatedData : {},
        rightSidebarReturn : {},
        wordCloudData : {},
        LiveMtmGraph : {},
        deletedTrade : {}
    }, 
    reducers: { 
        setSocketInstance: (state, action) => { 
            state.instance = action.payload;
        }, 
        clearSocketInstance: (state) => { 
            state.instance = null; 
        }, 
        setNewTrade: (state, action) => {
            state.newTrade = action.payload;
        },
        setTargetStoplossChange : (state, action) => {
            state.targetStoplossChange = action.payload;
        },
        setUpdatedData : (state, action) => {
            state.updatedData = action.payload;
        },
        setSidebarReturn : (state, action) => {
            state.rightSidebarReturn = action.payload;
        },
        setWordCloudData : (state, action) => {
            state.wordCloudData = action.payload;
        },
        setLiveMtmGraph : (state, action) => {
            state.LiveMtmGraph = action.payload;
        },
        setDeletedTrade : (state, action) => {
            state.deletedTrade = action.payload;
        }

    }, 
}); 

export const { setSocketInstance, clearSocketInstance, setNewTrade, setTargetStoplossChange, setUpdatedData, setSidebarReturn, setWordCloudData, setLiveMtmGraph, setDeletedTrade } = socketSlice.actions; 
export default socketSlice.reducer;

